import { Button, Flex, MicIcon, Text, Slider } from "@fluentui/react-northstar";
import TextArea from "antd/lib/input/TextArea";
import React, { useState, useRef, useEffect } from "react";
import AnnotationSystem from "../AnnotationSystem";
import { useIntelligentGrading } from "../../../../../../context/useIntelligentGrading";

const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
    .toString()
    .padStart(2, "0")}`;
};

const AudioResponse = ({ audio, isAnnotationMode }) => {
  const { annotations, setAnnotations } = useIntelligentGrading();

  const [isPlaying, setIsPlaying] = useState(false);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const audioRef = useRef(null);

  const index = annotations.findIndex(
    (annotation) => annotation.id === audio.id
  );

  const onAnnotationAdd = (annotation) => {
    let clonedAnnotations = [...annotations];
    clonedAnnotations[index].annotations.push(annotation);
    setAnnotations(clonedAnnotations);
  };

  const onAnnotationDelete = (id) => {
    let clonedAnnotations = [...annotations];
    clonedAnnotations[index].annotations = clonedAnnotations[
      index
    ].annotations.filter((annotation) => annotation.id !== id);
    setAnnotations(clonedAnnotations);
  };
  const onAnnotationEdit = (id, comment) => {
    let clonedAnnotations = [...annotations];
    clonedAnnotations[index].annotations = clonedAnnotations[
      index
    ].annotations.map((annotation) =>
      annotation.id === id ? { ...annotation, comment } : annotation
    );
    setAnnotations(clonedAnnotations);
  };

  useEffect(() => {
    const audio = audioRef.current;
    if (audio) {
      audio.addEventListener("loadedmetadata", () => {
        setDuration(audio.duration);
      });
      audio.addEventListener("timeupdate", () => {
        setCurrentTime(audio.currentTime);
      });
      audio.addEventListener("ended", () => {
        setIsPlaying(false);
        setCurrentTime(0);
      });
    }
  }, []);

  const togglePlayPause = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleSliderChange = (e, { value }) => {
    if (audioRef.current) {
      const newTime = (value / 100) * duration;
      audioRef.current.currentTime = newTime;
      setCurrentTime(newTime);
    }
  };

  return (
    <Flex gap="gap.small" column>
      <Text content="Audio Recording Analysis" weight="semibold" />
      <div
        style={{
          background: "#f9fafb",
          borderRadius: 10,
          padding: 16,
          border: "1px solid #e4e4e7",
        }}
      >
        <Flex column gap="gap.small">
          <Flex vAlign="center" gap="gap.small">
            <Button
              icon={<MicIcon />}
              content={isPlaying ? "Pause Audio" : "Play Audio"}
              onClick={togglePlayPause}
              style={{ padding: "0px 10px" }}
            />
            <Text content={`Duration:  ${formatTime(duration)}`} />
          </Flex>

          <Slider
            fluid
            min={0}
            max={100}
            value={duration ? (currentTime / duration) * 100 : 0}
            onChange={handleSliderChange}
            styles={{
              root: { margin: "10px 0" },
              track: { height: "8px" },
              rail: { height: "8px" },
              thumb: { width: "12px", height: "12px" },
            }}
          />
          <audio ref={audioRef} src={audio.info} style={{ display: "none" }} />
        </Flex>

        {/* <Flex column gap="gap.small">
          <Text content="AI Transcription:" weight="semibold" />
          <TextArea rows={4} readOnly />
        </Flex> */}
      </div>

      <Flex column gap="gap.small">
        <Text content="Audio Content" weight="semibold" />
        <AnnotationSystem
          isAnnotationMode={isAnnotationMode}
          essayText={audio.extractedText}
          annotations={annotations?.[index]?.annotations || []}
          onAnnotationAdd={onAnnotationAdd}
          onAnnotationDelete={onAnnotationDelete}
          onAnnotationEdit={onAnnotationEdit}
        />
      </Flex>
    </Flex>
  );
};

export default AudioResponse;
